import classNames from 'classnames'
import _ from 'lodash'
import React, {useMemo, useState} from 'react'
import {MdViewAgenda} from 'react-icons/md'
import {BsListUl} from "react-icons/bs";

export const ViewTypes = Object.freeze({
    HEADLINE: 'headline',
    LISTVIEW: 'list',
})

export const ViewContext = React.createContext({})

const ToggleView = ({
                        style,
                        children,
                        className,
                        renderListView,
                        renderHeadlineView,
                        defaultView = ViewTypes.HEADLINE,
                    }) => {
    const [view, setView] = useState(defaultView)

    const configs = [
        {
            value: ViewTypes.HEADLINE,
            component: BsListUl,
            render: renderHeadlineView,
        },
        {
            value: ViewTypes.LISTVIEW,
            component: MdViewAgenda,
            render: renderListView,
        },
    ]

    const {render: renderItem} = _.find(configs, {value: view}) || {}

    const switchComponent = useMemo(
        () => (
            <div
                style={style}
                className={classNames(
                    'p-1 border border-color-50 rounded-md hover:shadow flex gap-1',
                    className
                )}>
                {configs.map(({value, component: Component}) => (
                    <div className={classNames(
                        "p-1 flex flex-center rounded",
                        view === value ? 'bg-indigo-50' : 'background-200'
                    )}>
                        <Component
                            key={value}
                            size={16}
                            {...{
                              onClick: () => {
                                setView(value)
                              },
                              className: classNames(
                                  view === value
                                      ? 'text-indigo-600 font-bold'
                                      : 'text-color-500 cursor-pointer'
                              ),
                            }}
                        />
                    </div>
                ))}
            </div>
        ),
        [view, style]
    )
    return children({
        view,
        setView,
        renderItem,
        switchComponent,
    })
}

export const ViewProvider = ({children, ...props}) => {
    return (
        <ToggleView {...props}>
            {({...rest}) => (
                <ViewContext.Provider
                    value={{
                        ...rest,
                    }}>
                    {children}
                </ViewContext.Provider>
            )}
        </ToggleView>
    )
}

export default ToggleView
